const getCookieValue = (cookieName: string, cookieString: string) => {
  const cookies = cookieString.split(';').map((cookie) => cookie.trim());
  for (const cookie of cookies) {
    const [name, value] = cookie.split('=').map((part) => part.trim());
    if (name === cookieName) {
      return value;
    }
  }
  return null; // Cookie not found
};

export default getCookieValue;
